// src/css/comparePackageStyle.js

const styles = {
    container: {
        width: '100%',
        minHeight: '100vh',
        // pt: 10,
    },
    headerBox: {
        width: '100%',
        height: { xs: '250px', sm: '230px', md: '200px', lg: '200px' },
        padding: 0,
        backgroundSize: 'cover',         // Cover the entire area
        backgroundPosition: 'center',     // Center the image
        backgroundRepeat: 'no-repeat',    // Do not repeat the image
        position: 'relative',
        marginTop: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: "100%",
        // mt: 10,
    },
    headerTextTitle: {
        color: '#ffff',
        textAlign: 'center',
        fontFamily: 'Poppins, Arial, sans-serif',
        fontWeight: '600',
        fontSize: { xs: '25px', sm: '35px', md: '40px', lg: '45px' },
        px: 1,
        mb: 2,
    },
    headerText: {
        color: '#ffff',
        textAlign: 'center',
        fontFamily: 'Poppins, Arial, sans-serif',
        fontWeight: '600',
        fontSize: '16px',
        px: 2,
        // pb: 4,
    },
    gridContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '40px',
    },
    gridTitle: {
        color: '#000000',
        fontSize: '36px',
        fontFamily: 'Nunito',
        fontWeight: '600',
        textAlign: 'center',
        letterSpacing: '1px',
        px: 1,
    },
    gridText: {
        color: '#000000',
        fontSize: '18px',
        fontFamily: 'Nunito',
        fontWeight: '600',
        textAlign: 'center',
        px: 1,
    },
    tableHeading: {
        fontSize: '12px',
        fontFamily: 'Nunito',
        fontWeight: 700,
        borderBottom: '2px solid #E0E0E0',
    },
    tableText: {
        fontSize: '18px',
        fontFamily: 'Nunito',
        fontWeight: 400,
        borderBottom: '1px solid #E0E0E0',
    },
    gridFooterText: {
        color: '#000000',
        fontSize: '16px',
        fontFamily: 'Poppins, Arial, sans-serif',
        fontWeight: '400',
        textAlign: 'center',
        px: 1,
    }
};

export default styles;
